import { AssetType } from "../../api/enums";
import { CryptoFormInitialValues } from "../hooks/useCryptoForm";
import { OptionFormInitialValues } from "../hooks/useOptionsForm";
import { StockFormInitialValues } from "../hooks/useStocksForm";

export type PlaceOrderFormInitialValues = OptionFormInitialValues | StockFormInitialValues | CryptoFormInitialValues;

export function isStocks (data: PlaceOrderFormInitialValues) : data is StockFormInitialValues {
  return data.asset_type === AssetType.Stocks;
}

export function isOptions (data: PlaceOrderFormInitialValues) : data is OptionFormInitialValues {
  return data.asset_type === AssetType.Options;
}

export function isCrypto (data: PlaceOrderFormInitialValues) : data is CryptoFormInitialValues {
  return data.asset_type === AssetType.Crypto;
}